// src/pages/MainPanel/CreateExperiment/components/ResourceGroupSelector.jsx
import { Box, TextField, MenuItem } from "@mui/material";
import PropTypes from "prop-types";
import { INK_MUTED } from "../../../../theme/tokens";

/**
 * Reusable resource group dropdown.
 * Handles the "no groups assigned" error state internally.
 */
const ResourceGroupSelector = ({
  groups,
  selectedGroup,
  onGroupChange,
  disabled,
}) => {
  const noGroupsAssigned = Array.isArray(groups) && groups.length === 0;

  return (
    <TextField
      select
      fullWidth
      required
      value={selectedGroup?.id || ""}
      onChange={(e) => {
        const group = (groups || []).find((g) => g.id === e.target.value);
        onGroupChange(group || null);
      }}
      disabled={disabled || noGroupsAssigned}
      error={noGroupsAssigned}
      slotProps={{
        select: {
          displayEmpty: true,
          renderValue: (selected) => {
            if (!selected) {
              return (
                <Box component="span" sx={{ color: INK_MUTED }}>
                  Select a resource group
                </Box>
              );
            }
            const group = (groups || []).find((g) => g.id === selected);
            return group?.name || selected;
          },
        },
      }}
      helperText={
        noGroupsAssigned
          ? "You are not assigned to any resource group. Contact EFabric admins to request access."
          : selectedGroup?.description || " "
      }
      sx={{ mb: 4 }}
    >
      {(groups || []).map((g) => (
        <MenuItem key={g.id} value={g.id}>
          {g.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

ResourceGroupSelector.propTypes = {
  groups: PropTypes.array,
  selectedGroup: PropTypes.object,
  onGroupChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ResourceGroupSelector;
